import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    light: true,
    themes: {
      light: {
        mainPink: "#72401f",
        darkBlue: "#161853",
        lightBlueCstm: "#292C6D",
        calmWhite: "#FAEDF0",
        anchor: "#fff",
        topBarBg: "#2a2c39",
        chatBg: "#72401f",
        btnPrimary: "#72401f",
      },
    },
  },
});
